import React from 'react';
interface FeatureCardProps {
  icon: ReactNode;
  title: string;
  description: string;
}
export function FeatureCard({
  icon,
  title,
  description
}: FeatureCardProps) {
  return <div className="group relative bg-white p-8 rounded-2xl border border-gray-100 hover:border-blue-200 transition-all duration-300 hover:shadow-xl hover:-translate-y-1" data-id="element-117">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-118" />
      <div className="relative" data-id="element-119">
        <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-100 transition-colors duration-300" data-id="element-120">
          {icon}
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-121">{title}</h3>
        <p className="text-gray-600 leading-relaxed" data-id="element-122">{description}</p>
      </div>
    </div>;
}